import React, { useMemo, useState } from 'react'
import { TableMapHeader } from 'components'
import { TableMapHeaderProps } from '@evrekadev/evreka-ui-components'
import { useMapContext } from 'components/MapV2/MapProvider'
import { UilFilter } from '@iconscout/react-unicons'
import { useTranslation } from 'utils/useTranslation'
import { MapSettingsV2 } from './MapSettingsV2/MapSettingsV2'
import { MapSettingsModal } from './MapSettings/MapSettings'

export type MapHeaderProps = Pick<
  TableMapHeaderProps,
  | 'caption'
  | 'tableCaptionButtons'
  | 'tableCaptionButtonElement'
  | 'extraButtons'
  | 'bulkMode'
  | 'bulkActions'
  | 'toggle'
  | 'refresh'
  | 'onSelectAll'
  | 'onClearSelection'
  | 'selectedItemCount'
  | 'totalCount'
> & {
  noHeader?: boolean
}

export const MapHeader: React.FC = () => {
  const {
    caption,
    tableCaptionButtonElement,
    tableCaptionButtons,
    extraButtons,
    bulkMode,
    bulkActions,
    refresh,
    toggle,
    settings,
    columns,
    onFetch,
    setFilterOpen,
    noHeader,
    onChangeSettings,
    settingsV2,
  } = useMapContext()
  const { t } = useTranslation('components.map')

  const [isSettingsOpen, setIsSettingsOpen] = useState<boolean>(false)

  const toggleSettingsOpen = () => {
    setIsSettingsOpen((o) => !o)
    settings && onChangeSettings?.({ ...settings, isModalOpen: !isSettingsOpen })
  }
  const extraButtonsWithFilter = useMemo(() => {
    return [
      ...(extraButtons ?? []),
      ...(columns && onFetch
        ? [
            {
              icon: UilFilter,
              label: t('filters'),
              onClick: () => setFilterOpen((o) => !o),
              dataTestId: 'filter-button',
            },
          ]
        : []),
    ]
  }, [extraButtons, columns, onFetch])

  if (
    (!caption &&
      !tableCaptionButtonElement &&
      !tableCaptionButtons &&
      !extraButtons &&
      !bulkMode &&
      !bulkActions &&
      !refresh &&
      !toggle &&
      !settings &&
      !columns &&
      !onFetch) ||
    noHeader
  ) {
    return null
  }

  return (
    <div>
      <TableMapHeader
        caption={caption}
        tableCaptionButtonElement={tableCaptionButtonElement}
        extraButtons={extraButtonsWithFilter ?? []} // refresh depends on extraButtons
        bulkMode={bulkMode}
        bulkActions={bulkActions}
        tableCaptionButtons={tableCaptionButtons}
        toggle={toggle}
        refresh={refresh}
        settings={(settings || settingsV2) && toggleSettingsOpen}
        //   onClearSelection={onClearSelection}
        //   onSelectAll={onSelectAll}
        //   selectedItemCount={selectedMarkers?.length}
        //   totalCount={markers?.filter((m) => m.selectable)?.length}
      />
      {settings && <MapSettingsModal isOpen={isSettingsOpen} onClose={toggleSettingsOpen} />}
      {settingsV2 && <MapSettingsV2 isOpen={isSettingsOpen} onClose={toggleSettingsOpen} />}
    </div>
  )
}
